// extracted by mini-css-extract-plugin
module.exports = {"sectionBlock":"GoodbyeSection_sectionBlock__LHgE6"};